// extracted by mini-css-extract-plugin
export default {"startChatButtonContainer":"StartChatButton_startChatButtonContainer__BsbwJ","startChatButton":"StartChatButton_startChatButton__gW--b"};